module.exports = __webpack_public_path__ + "img/PostArztRoutine.b9529115.jpg";